import { Actions } from "../Actions";
import { routerHistory } from "../../Routing/Router";
import * as $ from "jquery";

export class RoutingActionsStatic extends Actions {
    /* tslint:disable:unified-signatures */
    public navigateTo(url: string): void;
    public navigateTo(url: string, scroll: boolean): void;
    public navigateTo(url: string, scroll?: boolean): void {
        if (scroll === undefined || scroll) {
            $(window).scrollTop(0);
        }        
        const isFirefox = typeof navigator !== "undefined" && /firefox/i.test(navigator.userAgent);
        if (isFirefox) {
            routerHistory.push(url);
        } else {
            setTimeout(() => routerHistory.push(url), 0);
        }
    }
}
